// Lets the filter panel apply what a user typed but did not Add when they close the field's drawer or the
// panel. The open text, number or date control registers a reader that returns the field's whole next
// selection while it holds such a value; closing reads it once.
import React from 'react';
import type {CustomFieldDraft} from './customFieldFilterSelection';

export interface CustomFieldDraftRegistry {
	register(filterType: string, read: () => unknown[] | null): () => void;
	collect(): CustomFieldDraft[];
}

export function createDraftRegistry(): CustomFieldDraftRegistry {
	const readers = new Map<string, () => unknown[] | null>();
	return {
		register(filterType, read) {
			readers.set(filterType, read);
			return () => {
				if (readers.get(filterType) === read) readers.delete(filterType);
			};
		},
		collect() {
			const drafts: CustomFieldDraft[] = [];
			readers.forEach((read, filterType) => {
				const values = read();
				if (values) drafts.push({filterType, values});
			});
			return drafts;
		},
	};
}

export const CustomFieldDraftContext = React.createContext<CustomFieldDraftRegistry | null>(null);
